import { IStore } from 'Store/.';
import { createSelector } from 'reselect';
import { OrderItemsIDs } from './reducer';

const getPerformance = (state: IStore) => state.orderItem.performance;
const getIsFetching = (state: IStore) => state.orderItem.isFetching;
const getIsFetchFailed = (state: IStore) => state.orderItem.isFetchFailed;
const getOrderItemID = (state: IStore) => state.orderItem.orderItemID;
const getIsInvalidOrderItem = (state: IStore) => state.orderItem.isInvalidOrderItem;

const getIsTimeSlot = createSelector(
  [getPerformance],
  (performance) => {
    return performance ? performance.isTimeSlot : false;
  },
);

const getPerformanceID = createSelector(
  [getPerformance],
  (performance) => {
    return performance ? performance.performanceID : null;
  },
);

const getEventID = createSelector(
  [getPerformance],
  (performance) => {
    return performance ? performance.eventID : null;
  },
);

const getIsSeatsAvailable = createSelector(
  [getPerformance],
  (performance) => {
    return performance && performance.seatTypes && performance.seatTypes.length > 0;
  },
);

const getSeatTypes = createSelector(
  [getPerformance],
  (performance) => {
    return performance ? performance.seatTypes : [];
  },
);

const getPerformanceStartTime = createSelector(
  [getPerformance],
  (performance) => {
    return performance ? performance.date : null;
  },
);

const getPerformanceEndTime = createSelector(
  [getPerformance],
  (performance) => {

    if (!performance || !performance.date || !performance.playLength) {
      return null;
    }
    
    const endDate = new Date();
    endDate.setTime(performance.date.getTime() + performance.playLength*60*1000);
    return endDate;
  },
);

const getIsOrderItemVoucher = createSelector(
  [getOrderItemID],
  (orderItemID) => {
    return orderItemID === OrderItemsIDs.VOUCHER;
  },
);

const getIsOpenForSale = createSelector(
  [getPerformance, getIsOrderItemVoucher],
  (performance, isOrderItemVoucher) => {
    return isOrderItemVoucher || (performance && performance.isOpenForSale);
  },
);

const getStartSaleDate = createSelector(
  [getPerformance],
  (performance) => {
    return performance && performance.startSaleDate ? performance.startSaleDate : null;
  },
);

export {
  getPerformance,
  getPerformanceID,
  getEventID,
  getIsFetching,
  getIsFetchFailed,
  getIsSeatsAvailable,
  getSeatTypes,
  getPerformanceStartTime,
  getPerformanceEndTime,
  getIsOrderItemVoucher,
  getIsTimeSlot,
  getIsInvalidOrderItem,
  getIsOpenForSale,
  getStartSaleDate,
};


// WEBPACK FOOTER //
// ./src/components/OrderItem/Redux/selectors.tsx